import React, { useState, useEffect } from "react";
import { Alert, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  Row,
  Col,
  FormGroup,
  Label,
  Input,
  Spinner,
  Container,
  Card,
  CardBody,
} from "reactstrap";
import Instructions from "./instructions";
import usePermission from "hooks/usePermission";
import { getSettings, updateCryptoDepositSettings } from "store/actions";
import LoadingButton from "../../../components/shared/LoadingButton";

const CryptoDepositSettings = () => {
  const dispatch = useDispatch();
  const { settings, loading, error } = useSelector(({ Settings }) => Settings);
  const { hasPermission } = usePermission();
  const permissions = {
    add: false,
    edit: hasPermission("edit_crypto_deposit_setting"),
    delete: false,
  };

  const [fields, setFields] = useState({
    awardPerUsdt: 0,
    specialUserAwardPerUsdt: 0,
    status: "disabled",
  });

  useEffect(() => {
    dispatch(getSettings());
  }, [dispatch]);

  useEffect(() => {
    if (settings?._id) {
      // console.info("settings", settings);
      const depositReward = settings.depositReward;
      setFields(() => ({
        awardPerUsdt: depositReward?.awardPerUsdt,
        specialUserAwardPerUsdt: depositReward?.specialUserAwardPerUsdt,
        status: depositReward?.status,
      }));
    }
  }, [settings]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFields((prev) => ({
      ...prev,
      [name]: ["awardPerUsdt", "specialUserAwardPerUsdt"].includes(name)
        ? Number(value) || ""
        : value,
    }));
  };

  const submit = async () => {
    dispatch(
      updateCryptoDepositSettings({
        data: { ...fields },
      })
    );
  };
  // console.info(fields, "FIELDS");
  // console.info("Permissions:", permissions);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col sm={12} lg={12}>
              <Card>
                <CardBody className="spinner-content">
                  {error && typeof error === "string" ? (
                    <Alert color="danger">{error}</Alert>
                  ) : null}

                  {loading && <div className="spinner"></div>}

                  <Col lg={8}>
                    <Instructions />
                  </Col>

                  <Col lg={8}>
                    <Row>
                      <Col md={6}>
                        <FormGroup>
                          <Label>Award Per Usdt</Label>
                          <Input
                            className=""
                            type="number"
                            placeholder="Award Per Usdt"
                            value={fields?.awardPerUsdt}
                            name="awardPerUsdt"
                            onChange={(e) => handleChange(e)}
                          />
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup>
                          <Label>Special User Award Per Usdt</Label>
                          <Input
                            className=""
                            type="number"
                            placeholder="Special User Award Per Usdt"
                            value={fields?.specialUserAwardPerUsdt}
                            name="specialUserAwardPerUsdt"
                            onChange={(e) => handleChange(e)}
                          />
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup>
                          <Label>Status</Label>
                          <select
                            style={{ height: 50 }}
                            name="status"
                            className="form-control"
                            value={fields?.status}
                            onChange={handleChange}
                          >
                            <option value="enabled">Enabled</option>
                            <option value="disabled">Disabled</option>
                          </select>
                        </FormGroup>
                      </Col>

                      <Col md={6} />
                      {permissions.edit ? (
                        <Col className="d-flex justify-content-end mt-3">
                          <LoadingButton
                            onClick={submit}
                            className="btn btn-primary btn-lg"
                            loading={loading}
                            disabled={loading}
                          >
                            {!loading ? <>Save Changes</> : ""}
                          </LoadingButton>
                        </Col>
                      ) : null}
                    </Row>
                  </Col>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default CryptoDepositSettings;